import { React, useState, useEffect, useRef, useContext } from "react";
import PCModal from "../PCModal";
import Select from 'react-select';
import Button from "@mui/material/Button";
import { AppContext } from '../../../AppStore';
import GridNoRow from '../../../common/GridNoRow';
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import Swal from "sweetalert2";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import Moment from 'moment';
import "moment/locale/ko";

function MachineProductionStatisticsModal({ title, onClose, originRows, selectDataID, keyword, tabID }) {
  const appStore = useContext(AppContext);
  const [tabPanelHeight, setTabPanelHeight] = useState(400);
  const [dataRows, setDataRows] = useState([]);
  const [dataColumns, setDataColumns] = useState([]);
  const [dataColumnVisibilityModel, setDataColumnVisibilityModel] = useState([]);
  const [modalTabID, setModalTabID] = useState('1');

  const handleSetting = () => {
    
    setDataColumns([
      { field: 'id', headerName: 'id', width: 0, headerAlign: 'center', align:'center' },
      { field: 'gijun_month', headerName: '기준년월', width: 73, headerAlign: 'center', align:'center'},
      { field: 'gijun_date', headerName: '기준일자', width: 94, headerAlign: 'center', align:'center'},
      { field: 'machine_name', headerName: '설비명', width: 120, headerAlign: 'center', align:'center' },
      { field: 'project_name', headerName: '프로젝트', width: 80, headerAlign: 'center', align:'center' },
      { field: 'item_name', headerName: '품목명', width: 120, headerAlign: 'center', align:'left' },
      { field: 'item_spec', headerName: '규격', width: 160, headerAlign: 'center', align:'left' },
      { field: 'produce_count', headerName: '생산수량', width: 75, headerAlign: 'center', align:'right'},
      { field: 'produce_complete_count', headerName: '양품수량', width: 75, headerAlign: 'center', align:'right'},
      { field: 'produce_error_count', headerName: '불량수량', width: 75, headerAlign: 'center', align:'right'}
    ]);

    setDataColumnVisibilityModel({
      id: false
    });
    
  }

  const handleInitSelect = () => {
      setDataRows(
        originRows
          .filter((item) => {
            // 1) 실적이 전부 0이면 제외
            if (
              Number(item.produce_count) === 0 &&
              Number(item.produce_complete_count) === 0 &&
              Number(item.produce_error_count) === 0
            ) {
              return false;
            }

            // 2) 날짜/월 선택 필터
            if (!selectDataID) return true;

            // 2025-11-11 형식이면 gijun_date 기준
            if (/^\d{4}-\d{2}-\d{2}$/.test(selectDataID)) {
              return item.gijun_date === selectDataID;
            }

            // 2025-11 형식이면 gijun_month 기준
            if (/^\d{4}-\d{2}$/.test(selectDataID)) {
              return item.gijun_month === selectDataID;
            }

            // 그 외 형식이면 필터 없이
            return true;
          })
          .map((item, index) => ({
            id: index,
            gijun_month: item.gijun_month,
            gijun_date: item.gijun_date,
            machine_name: item.machine_name,
            project_name: item.project_name,
            item_name: item.item_name,
            item_spec: item.item_spec,
            produce_count: item.produce_count
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            produce_complete_count: item.produce_complete_count
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
            produce_error_count: item.produce_error_count
              .toString()
              .replace(/\B(?=(\d{3})+(?!\d))/g, ","),
        }))
      );
  };

  useEffect(() => {
    //렌더링 될 때 마다 실행된다.
  });

  useEffect(() => {
    // Mount 될때만 실행된다.
    handleSetting();
    setTabPanelHeight(400);
  }, []);

  useEffect(() => {
    handleInitSelect();
  }, [originRows]);

  const handleTabID = (event, newTabID) => {
    setModalTabID(newTabID);
  };

  return (
    <PCModal onClose={onClose} title={title}>
        <div className="modal" style={{ height: 'auto', overflowY: 'auto'}}>
          <TabContext value={modalTabID}>
            <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
              <TabList onChange={handleTabID} style={{ paddingLeft: '20px'}}>
                <Tab label="상세통계" value="1" />
              </TabList>
            </Box>
            <TabPanel value="1" style={ { height: tabPanelHeight } }>
              <div className="modal_grid">
                <DataGrid
                  rows={dataRows}
                  columns={dataColumns}
                  columnVisibilityModel={dataColumnVisibilityModel}
                  onProcessRowUpdateError={(error) => error}
                  AlternatingRowBackground="LavenderBlush"
                  rowsPerPageOptions={[20, 50, 100]}
                  initialState={{ 
                      density: 'compact'
                  }}
                  slots={{
                      noRowsOverlay: GridNoRow,
                  }}
                  disableColumnSorting 
                />
              </div>
            </TabPanel>
          </TabContext>
          <table className="ModalTABLE">
            <tbody>
              <tr>
                <td className="ModalTD" colSpan={2}>
                  <div className="modal_action">
                    <div className="modal_button">
                      <Button 
                        onClick={()=> { onClose?.(); }}
                        className="btn-p"
                        sx={{  
                            m: 1, 
                            fontSize: 18,  
                            color: "white", 
                            borderColor: "#808080", 
                            backgroundColor: "#808080",
                            ":hover": { boxShadow: "2px 2px 2px #808080" , backgroundColor: "#808080", borderColor: "#808080"}
                        }} 
                        variant="outlined">
                        닫기
                      </Button>
                    </div>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </PCModal>
  );
}

export default MachineProductionStatisticsModal;